module.exports = __webpack_public_path__ + "static/media/BB10s.3663ff5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/desktop/BB10s.svg
// module id = 107
// module chunks = 0